// extracted by mini-css-extract-plugin
export default {"title":"_340d21855a","inner_title":"a095504add","charge_btn":"_6aa99c4194"};